import React from "react";

// Base Icon component with common props
const Icon = ({ children, size = 16, className = "", style, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    className={className}
    style={{ display: "block", ...style }}
    {...props}
  >
    {children}
  </svg>
);

export const PlusIcon = (props) => (
  <Icon {...props}>
    <path d="M8 2.625a.75.75 0 01.75.75V7.625h4.25a.75.75 0 010 1.5H8.75v4.25a.75.75 0 01-1.5 0V9.125H3a.75.75 0 010-1.5H7.25V3.375A.75.75 0 018 2.625z" />
  </Icon>
);

export const SearchIcon = (props) => (
  <Icon {...props}>
    <path d="M10.68 11.74a6 6 0 01-7.922-8.982 6 6 0 018.982 7.922l3.04 3.04a.749.749 0 01-.326 1.275.749.749 0 01-.734-.215l-3.04-3.04zm-4.49-9.24a4.5 4.5 0 100 9 4.5 4.5 0 000-9z" />
  </Icon>
);

export const EditIcon = (props) => (
  <Icon {...props}>
    <path d="M11.013 1.427a1.75 1.75 0 012.474 0l1.086 1.086a1.75 1.75 0 010 2.474l-8.61 8.61c-.21.21-.47.364-.756.445l-3.251.93a.75.75 0 01-.927-.928l.929-3.25a1.75 1.75 0 01.445-.758l8.61-8.61zm1.414 1.06a.25.25 0 00-.354 0L10.811 3.75l1.439 1.44 1.263-1.263a.25.25 0 000-.354l-1.086-1.086zM11.189 6.25L9.75 4.81l-6.286 6.287a.25.25 0 00-.064.108l-.558 1.953 1.953-.558a.249.249 0 00.108-.064l6.286-6.286z" />
  </Icon>
);

export const DeleteIcon = (props) => (
  <Icon {...props}>
    <path d="M6.5 1.75a.25.25 0 01.25-.25h2.5a.25.25 0 01.25.25V3h-3V1.75zm4.5 0V3h2.25a.75.75 0 010 1.5H13v8.75A1.75 1.75 0 0111.25 15h-6.5A1.75 1.75 0 013 13.25V4.5h-.75a.75.75 0 010-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75zM4.5 4.5v8.75c0 .138.112.25.25.25h6.5a.25.25 0 00.25-.25V4.5h-7zm2.5 2.5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5a.75.75 0 01.75-.75zm3 0a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5a.75.75 0 01.75-.75z" />
  </Icon>
);

export const CodeIcon = (props) => (
  <Icon {...props}>
    <path d="M4.72 3.22a.75.75 0 011.06 1.06L2.06 8l3.72 3.72a.75.75 0 11-1.06 1.06L.47 8.53a.75.75 0 010-1.06l4.25-4.25zm6.56 0a.75.75 0 10-1.06 1.06L13.94 8l-3.72 3.72a.75.75 0 101.06 1.06l4.25-4.25a.75.75 0 000-1.06l-4.25-4.25z" />
  </Icon>
);

export const ChartIcon = (props) => (
  <Icon {...props}>
    <path d="M1.5 1.75a.75.75 0 00-1.5 0v12.5c0 .414.336.75.75.75h14.5a.75.75 0 000-1.5H1.5V1.75zm14.28 2.53a.75.75 0 00-1.06-1.06L10 7.94 7.53 5.47a.75.75 0 00-1.06 0L3.22 8.72a.75.75 0 001.06 1.06L7 7.06l2.47 2.47a.75.75 0 001.06 0l5.25-5.25z" />
  </Icon>
);

export const ChevronLeftIcon = (props) => (
  <Icon {...props}>
    <path d="M9.78 12.78a.75.75 0 01-1.06 0L4.47 8.53a.75.75 0 010-1.06l4.25-4.25a.75.75 0 011.06 1.06L6.06 8l3.72 3.72a.75.75 0 010 1.06z" />
  </Icon>
);

export const ChevronRightIcon = (props) => (
  <Icon {...props}>
    <path d="M6.22 3.22a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 010-1.06z" />
  </Icon>
);

export const CheckIcon = (props) => (
  <Icon {...props}>
    <path d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z" />
  </Icon>
);

export const CopyIcon = (props) => (
  <Icon {...props}>
    <path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z" />
    <path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z" />
  </Icon>
);

export const InfoIcon = (props) => (
  <Icon {...props}>
    <path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm9 3a1 1 0 11-2 0 1 1 0 012 0zM6.92 5.5c.036-.146.087-.29.154-.427.066-.136.16-.26.28-.372C7.49 4.56 7.673 4.5 7.875 4.5c.18 0 .343.042.488.126.145.083.259.2.342.35.083.15.125.319.125.507 0 .186-.04.354-.118.505a1.47 1.47 0 01-.314.397.89.89 0 00-.23.288c-.054.11-.08.229-.08.357h1.125c0-.235.06-.454.18-.656.12-.202.283-.376.488-.523a2.32 2.32 0 00.408-.4c.11-.138.196-.29.257-.453A1.78 1.78 0 0010.75 4c0-.365-.094-.699-.28-.999a2.047 2.047 0 00-.773-.706C9.328 2.098 8.89 2 8.375 2c-.606 0-1.14.13-1.601.39a2.31 2.31 0 00-1.094 1.61z" />
  </Icon>
);

export const ErrorIcon = (props) => (
  <Icon {...props}>
    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0zm9.78-2.22a.75.75 0 0 0-1.06-1.06L8 6.94 5.78 4.72a.75.75 0 0 0-1.06 1.06L6.94 8l-2.22 2.22a.75.75 0 1 0 1.06 1.06L8 9.06l2.22 2.22a.75.75 0 1 0 1.06-1.06L9.06 8l2.22-2.22z" />
  </Icon>
);

export const WarningIcon = (props) => (
  <Icon {...props}>
    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
  </Icon>
);

export const EmptyIcon = (props) => (
  <Icon {...props}>
    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0zm7.25-3.25a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5z" />
  </Icon>
);

export const CloseIcon = (props) => (
  <Icon {...props}>
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
  </Icon>
);

export const BookIcon = (props) => (
  <Icon {...props}>
    <path d="M0 1.75A.75.75 0 01.75 1h4.253c1.227 0 2.317.59 3 1.501A3.744 3.744 0 0111.006 1h4.245a.75.75 0 01.75.75v10.5a.75.75 0 01-.75.75h-4.507a2.25 2.25 0 00-1.591.659l-.622.621a.75.75 0 01-1.06 0l-.622-.621A2.25 2.25 0 005.258 13H.75a.75.75 0 01-.75-.75V1.75zm7.251 10.324V2.922a2.25 2.25 0 00-2.248-2.172H1.5v9.5h3.757a3.75 3.75 0 011.994.574zM8.755 2.922v9.152a3.75 3.75 0 011.994-.574H14.5v-9.5h-3.495A2.25 2.25 0 008.755 2.922z" />
  </Icon>
);

export const ChatIcon = (props) => (
  <Icon {...props}>
    <path d="M1.5 2.75a.25.25 0 01.25-.25h12.5a.25.25 0 01.25.25v8.5a.25.25 0 01-.25.25h-6.5a.75.75 0 00-.53.22L4.5 14.44v-2.19a.75.75 0 00-.75-.75h-2a.25.25 0 01-.25-.25v-8.5zM1.75 1A1.75 1.75 0 000 2.75v8.5C0 12.216.784 13 1.75 13H3v1.543a1.457 1.457 0 002.487 1.03L8.061 13h6.189A1.75 1.75 0 0016 11.25v-8.5A1.75 1.75 0 0014.25 1H1.75z" />
  </Icon>
);

export const MoreVerticalIcon = (props) => (
  <Icon {...props}>
    <path d="M8 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 14a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
  </Icon>
);

const Icons = {
  Plus: PlusIcon,
  Search: SearchIcon,
  Edit: EditIcon,
  Delete: DeleteIcon,
  Code: CodeIcon,
  Chart: ChartIcon,
  ChevronLeft: ChevronLeftIcon,
  ChevronRight: ChevronRightIcon,
  Check: CheckIcon,
  Copy: CopyIcon,
  Info: InfoIcon,
  Error: ErrorIcon,
  Warning: WarningIcon,
  Empty: EmptyIcon,
  Close: CloseIcon,
  Book: BookIcon,
  Chat: ChatIcon,
  MoreVertical: MoreVerticalIcon,
};

export default Icons;
